<script>
import _ from 'lodash';
import { appendQueryParam } from '@/utils';
import { nullable } from '@/utils/propTypes';

export default {
  props: {
    organizationId: nullable(String),
    projectId: nullable(String),
    referralCode: nullable(String),
    teamId: nullable(String),
  },
  data: () => ({
    isLoading: false,
    social: null,
  }),
  methods: {
    signup() {
      const authUrl = this.getLinkedinAuthUrl();
      window.location.assign(authUrl);
    },
    getLinkedinAuthUrl() {
      const isDev = window.location.host === 'localhost:8085';
      const url = isDev ? '//localhost:8080/auth/linkedin' : '/auth/linkedin';

      const appendQueryParams = _.flow([
        appendQueryParam('activity', 'respondentsignup'),
        appendQueryParam('referralCode', this.referralCode),
        appendQueryParam('projectId', this.projectId),
        appendQueryParam('organizationId', this.organizationId),
        appendQueryParam('teamId', this.teamId),
        appendQueryParam(
          'backto',
          `//${window.location.host}/respondents/v2/personal`
        ),
        appendQueryParam('isDev', isDev ? 'true' : null),
      ]);

      return appendQueryParams(url);
    },
  },
};
</script>

<template>
  <v-btn
    :loading="isLoading"
    :disabled="isLoading"
    block
    outlined
    @click.native="isLoading = true"
    @click.exact="signup"
  >
    <v-icon left color="#0077b5" :size="18"> fab fa-linkedin </v-icon>
    <v-spacer />
    Continue with Linkedin
    <v-spacer />
  </v-btn>
</template>
